import * as Endpoints from '../Entities/EndPoints'
import Axios from '../Axios'

const API = Axios.getInstance
// const API_FORMDATA = Axios.getInstanceForFormData

export const GetAllBodyPreview = (userId, orgId, bodyType, roleId) => {
    const params = { userId, orgId, bodyType, roleId }
    return API(Endpoints.API_ENDPOINT)
        .get(Endpoints.GET_ALL_BODY_PREVIEW, { params })
        .then((response) => response)
        .catch((err) => ({ err }))
}
